import React from 'react';
import { extractObjectFromDataTable } from 'hooks/datatable';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import FPLink from 'UI/components/atoms/FPLink';
import { ContactEntityMapping } from 'UI/constants/entityTypes';
import { KEYWORDS_COLUMN, PhoneColumns } from 'UI/constants/sharedColumns';

export const EmployeesCustomRender = {
  contactName: value => (
    <FPLink
      itemId={value?.id}
      linkProps={{
        type: 'local',
        url: value?.is_name ? EntityRoutes.ContactProfile : EntityRoutes.CandidateProfile
      }}
    >
      {value?.full_name}
    </FPLink>
  )
};

export const getEmployeeRole = ({ columns, rowData }) => {
  const item = extractObjectFromDataTable(columns, ['roleId'], rowData);
  const roleId = item?.roleId;
  const itemRole = ContactEntityMapping[roleId];
  return itemRole;
};

export const EmployeesColumns = [
  {
    name: 'id',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'full_name',
    label: 'Name',
    options: {
      display: true,
      sort: false,
      renderer: 'contactName'
    }
  },
  {
    name: 'title',
    label: 'Title',
    options: {
      display: true,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'phone',
    label: 'Phone',
    options: {
      sort: false,
      display: false,
      renderer: 'phone'
    }
  },
  {
    name: 'mobile',
    label: 'Other Phone',
    options: {
      sort: false,
      display: false,
      renderer: 'phone'
    }
  },
  {
    name: 'email',
    label: 'Email',
    options: {
      display: true,
      sort: false,
      renderer: 'email'
    }
  },
  {
    name: 'personal_email',
    label: 'Other Email',
    options: {
      display: false,
      sort: false,
      renderer: 'email'
    }
  },
  {
    name: 'location',
    label: 'Location',
    options: {
      display: false,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'industry',
    label: 'Industry',
    options: {
      display: false,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'specialty',
    label: 'Specialty',
    options: {
      display: false,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'subspecialty',
    label: 'Subspecialty',
    options: {
      display: false,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'position',
    label: strings.shared.fields.jobFunction,
    options: {
      display: true,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'roleTitle',
    label: 'Role',
    options: {
      renderer: 'default',
      display: true,
      sort: false
    }
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      display: false,
      sort: false,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-candidate-status',
          variant: 'outlined'
        }
      }
    }
  },
  {
    name: 'type',
    label: 'Type',
    options: {
      display: false,
      sort: false,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          baseClass: 'chip-candidate-type',
          labelKey: 'title'
        }
      }
    }
  },
  {
    name: 'created_at',
    label: 'Added Date',
    options: {
      display: false,
      sort: false,
      renderer: 'date'
    }
  },
  {
    name: 'last_activity_title',
    label: 'Last Activity',
    options: {
      display: false,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'last_activity_date',
    label: 'Last Activity on',
    options: {
      display: false,
      sort: true,
      renderer: 'date'
    }
  },
  {
    name: 'last_activity_by',
    label: 'Last Activity by',
    options: {
      display: false,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'roleId',
    options: {
      display: 'excluded',
      sort: false
    }
  },
  KEYWORDS_COLUMN
];

export const EmployeeColumnsWithoutLegacyPhones = EmployeesColumns.filter(
  column =>
    column.name !== PhoneColumns.PHONE_LEGACY.name &&
    column.name !== PhoneColumns.OTHER_PHONE_LEGACY.name
);

export const EmployeesVirtualProps = [
  {
    propName: 'full_name',
    attributes: ['full_name', 'id', 'is_name']
  },
  {
    propName: 'phoneNumbers',
    attributes: ['phone', 'phones']
  }
];
